import { Injectable } from '@angular/core';
import { NotifyComponent } from '@bp2s/core/notify/notify.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DEFAULT_NOTIFICATION_DURATION } from '@bp2s/core/consts/global-notification.const';


@Injectable({
  providedIn: 'root'
})
export class GlobalNotificationService {

  constructor(private snackbar: MatSnackBar) { }

  info(msg, duration=DEFAULT_NOTIFICATION_DURATION){
    this.showNotification(msg,'info', 'info-snack', duration);
  }
  error(msg, duration=DEFAULT_NOTIFICATION_DURATION){
    this.showNotification(msg,'error', 'error-snack', duration);
  }
  success(msg, duration=DEFAULT_NOTIFICATION_DURATION){
    this.showNotification(msg,'success', 'success-snack', duration);
  }
  simulationInfo(msg, duration=DEFAULT_NOTIFICATION_DURATION){
    this.showNotification(msg,'info', 'info-snack', duration);
  }
  showNotification(msg, notifyType, panelClass=null, duration=DEFAULT_NOTIFICATION_DURATION){
    const options = {type: notifyType , message: msg, duration };
    panelClass = panelClass || 'bnppSnackBar';
    this.snackbar.openFromComponent(NotifyComponent, {
      data: options,
      panelClass: panelClass,
      duration
    });
  }
}
